import React, { useEffect, useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Context } from '../context/Context'

export default function Header() {

  const { lang, isShow, handleIsShowHeader, theme, showSideBar, handleSideMenu, handleLangModal, isNewUser } = useContext(Context);
  const history = useHistory();

  const backPageArrow = require("../assets/red/back_page_arrow.png");

  function goBack() {
    handleLangModal(false); // hide show lang modal
    const pathName = window.location.pathname
    console.log("path name => ", pathName)
    if (pathName === '/') {
      console.log("you are already on home page")
    } else if (pathName === '/1' || pathName === '/2' || pathName === '/3' || pathName === '/4' || pathName === '/5' ||
      pathName === '/6' || pathName === '/7' || pathName === '/8') {
      history.push("/")
    } else if (pathName.includes("quran_detail")) {
      history.push("/2")
    } else if (pathName.includes("hadesList") && theme === "green") {
      history.push("/7")
    } else if (pathName.includes("dua_detail")) {
      history.push("/3")
    } else if (pathName.includes("islamicStoriesDetails")) {
      history.push("/7")
    } else if (pathName.includes("ramdan_list")) {
      history.push("/8")
    }else if(pathName.includes("allVideos")){
        history.push("/9")
    }else if(pathName.includes("allAudios")){
        history.push("9")
    }else {
      history.push("/")
    }
  }

  return (
    <>
      <div className={`fixed ${theme === "red" ? "bg-red_top_header h-[5.4rem] bg-no-repeat -top-2 bg-cover  mx-0" : "bg-top_header h-[3.4rem]"} bg-center w-full max-w-500px z-30`}>
        <div className='py-4 relative'>
          {isShow && <div className={" ml-2 -mt-1" } onClick={() => { goBack() }}> <img style={{ width: "2rem" }} src={backPageArrow} /></div>}
          {/* {!showSideBar && !isShow && <div className={theme === "red" ? " text-left pl-4 pt-3 text-white" : `absolute left-2 top-2 py-2 z-20  rounded-full px-1`} onClick={() => handleSideMenu(true)}>{!isNewUser &&
         <svg viewBox='-5 0 12 8' width='25'>
         <line y2='8'
               stroke='#fff'
               stroke-width='10'
               stroke-dasharray='2 1'/>
       </svg>
          }  </div>} */}

          {theme === "green" && <div className='absolute right-0 ml-10 mr-10 left-0 top-2 text-darkGreen font-bold text-2xl' >{localStorage.getItem('sermonTitle') ? localStorage.getItem('sermonTitle') : 'إسلامي'}     </div>}
        </div>
      </div>
    </>

  )
}
